/* The downscaler is loaded at the first upload, not with the first screen (w7-02: the initial
   route's budget). */
import type { DownscaleOptions } from './downscale';

import { SMALL_FILE_BYTES } from './limits';

export { BARCODE_MAX_SIDE, DOCUMENT_MAX_SIDE } from './limits';
export type { Decoded, DownscaleOptions } from './downscale';

const load = () => import('./downscale');

/** Fetch the downscaler ahead of the first photo (a screen with a file picker mounts). */
export function preloadDownscale(): void {
  load().catch(() => undefined);
}

/** See downscale.ts. Never rejects: any failure, the chunk's included, means the original goes up. */
export function downscaleImage(file: File, options?: DownscaleOptions): Promise<File> {
  // What goes up as it is needs no downscaler: a small file (most screenshots, every test file).
  if (file.size < SMALL_FILE_BYTES) return Promise.resolve(file);
  return load().then(
    (m) => m.downscaleImage(file, options),
    () => file,
  );
}
